import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { Heading } from './NavMenu';

export class CensusTasks extends React.Component<RouteComponentProps<{}>, {}> {
   public render() {
        return <div>
            <Heading value='Tasks for Census' />
        </div>;
    }
}